import { useContext } from "react";
import { EventDetailsContext } from "./context";

export function useEventDetails() {
  const context = useContext(EventDetailsContext);
  if (context === undefined) {
    throw new Error(
      "useEventDetails must be used within an EventDetailsProvider"
    );
  }
  return context;
}
